import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { DeclarationModel, FormsData } from '../models/DashboardModel';
import { SharingService } from 'src/app/modules/shared/shared.service';

@Injectable({
    providedIn: 'root'
})
export class DeclarationService {
    [x: string]: any;
   
    APIURL = environment.apiURL;
    serviceUrl: string;
    ChangeRequestUri: string;
    private _jsonURL = 'assets/dataMockups/declarationMockup.json';

    
  constructor(private httpClient: HttpClient, private sharingService: SharingService) {
    }
    getDeclarationMockupData(): Observable<any> {
        return this.httpClient.get<any>(this._jsonURL);
    }
    getFormsDeclarationData(clientNo: number, year: number, noIntervenant: number, languageInput: string): Observable<FormsData> {
        
          const uri = `${this.APIURL + "api/user/GetDeclationFormsData"}/${clientNo}/${year}/${noIntervenant}/${languageInput}`;
          return this.httpClient.get<FormsData>(uri,{
              headers: this.sharingService.createAuthorizationHeader()
            });
    }
    submitFormsDeclarationData(submitData): Observable<any> { 
        const uri = `${this.APIURL + "api/user/submitFormsDeclarationData"}/${submitData}`;
        return this.httpClient.post<any>(uri,submitData,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    downloadPdfService(pdfInputData): Observable<any> {
        const uri = `${this.APIURL + "api/user/downloadPdfService"}/${pdfInputData}`;
        return this.httpClient.post<any>(uri,pdfInputData,{
            headers: this.sharingService.createAuthorizationHeader()
          });
      }
}
